import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import ListItem from 'shared/components/vxl/ListItem/ListItem';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import theme from 'shared/styles/theme';

const ContactSupport = () => {
  const router = useRouter();
  const { t: translatedTextReactivation } = useTranslation('reactivation', {
    keyPrefix: 'contactSupport',
  });

  useViewDidFocusScreenAnalyticsEvent({
    key: 'contact-support-reactivation',
    customAttributes: {
      reactivation_flow: 'true',
    },
  });

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: '',
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={() => router.push('/reactivation')}
              primaryIcon={<Icon iconKey="CLOSE" iconSize="MD" />}
            />
          ),
        }}
      />
      <View>
        <View style={styles.textContainer}>
          <TitleLgText>{translatedTextReactivation('title')}</TitleLgText>
          <BodyBaseText>
            {translatedTextReactivation('description')}
          </BodyBaseText>
        </View>
      </View>
      <ListItem
        primaryCopy={translatedTextReactivation('listItem.title')}
        onPress={() => {
          router.push({
            pathname: '/reactivation/help/call-us',
          });
        }}
        analyticsId="contactSupport"
        customAttributes={{
          reactivation_flow: 'true',
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
  },

  textContainer: {
    display: 'flex',
    gap: theme.spacing.m,
    padding: theme.spacing.m,
  },
});

export default ContactSupport;
